import client from './client';

// 백테스트 실행
export const runBacktest = async (config) => {
  // 거래대금 억원 -> 원 변환
  const requestConfig = {
    ...config,
    min_trading_value: config.min_trading_value * 100000000  // 억원 -> 원
  };
  const response = await client.post('/backtest/run', requestConfig);
  return response.data;
};

// 종목 리스트 조회
export const getStockList = async () => {
  const response = await client.get('/backtest/stocks');
  return response.data;
};
